import React from 'react';
import { Link } from 'react-router-dom';
import '../../onboarding/onboarding.css';

const ResetSuccessStep = () => (
  <div className="ob-root">
    <div className="ob-page">
      <div className="ob-card" style={{ alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
        <div style={{ fontSize: 46, marginBottom: 18 }}>✅</div>
        <h1 className="ob-title">Password reset</h1>
        <p className="ob-subtitle">
          Your password has been updated. Use it the next time you sign in.
        </p>
        <Link to="/auth/sign-in" className="ob-btn-primary" style={{ display: 'block', textDecoration: 'none', textAlign: 'center' }}>
          Back to sign in
        </Link>
      </div>
    </div>
  </div>
);

export default ResetSuccessStep;
